import type CalendarModuleCommand from './schema/CalendarModuleCommands';
import { createStore } from 'satcheljs';

export interface CalendarModuleCommandStore {
    moduleCommand: CalendarModuleCommand;
    formId: string;
}

const getStore = createStore<CalendarModuleCommandStore>('calendarModuleCommandStore', {
    moduleCommand: null,
    formId: null,
});
const store = getStore();
export default store;
